import { loginRequest } from "../configs/authConfig";

function apiCall(url, fetchOptions, resolveF, instance, accounts) {
  if (resolveF) {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then(async (responseToken) => {
        if (fetchOptions.headers == null) {
          fetchOptions.headers = new Headers();
        }
        var bearer = "Bearer " + responseToken.accessToken;
        fetchOptions.headers.append("Authorization", bearer);
        fetchOptions.headers.append("Content-Type", "application/json");
        fetchOptions.headers.append("Access-Control-Allow-Origin", "*");

        return window
          .fetch(process.env.REACT_APP_API + url, fetchOptions)
          .then((res) => res.json())
          .then((json) => {
            resolveF(json);
          });
      });
  } else {
    return instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then(async (responseToken) => {
        if (fetchOptions.headers == null) {
          fetchOptions.headers = new Headers();
        }
        var bearer = "Bearer " + responseToken.accessToken;
        fetchOptions.headers.append("Authorization", bearer);
        fetchOptions.headers.append("Content-Type", "application/json");

        return window
          .fetch(process.env.REACT_APP_API + url, fetchOptions)
          .then((res) => res.json());
      });
  }
}

export default apiCall;
